// extracted by mini-css-extract-plugin
export default {"centeredIconCell":"TransactionListPage_centeredIconCell__HPKA5","mobileTypeAndPaymentCell":"TransactionListPage_mobileTypeAndPaymentCell__3CRNJ"};